import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '@sm/wds-react';
import { InlineList, InlineListItem } from '../InlineList';

const BillingAddress = props => {
  const { country } = props;
  return (
    <Row>
      <Col data-testid="BillingAddress__Footer">
        <InlineList noMargin>
          <Choose>
            <When condition={country === 'US'}>
              <>
                <InlineListItem>
                  SurveyMonkey 3050 South Delaware Street, San Mateo, CA, 94403,
                  USA
                </InlineListItem>
              </>
            </When>
            <When condition={country === 'BR'}>
              <>
                <InlineListItem>
                  SurveyMonkey Brasil Internet Ltda. Rua Joaquim Floriano, Nº
                  243, Suíte 113, Itaim Bibi, São Paulo, SP, CEP 04534-010,
                  Brasil
                </InlineListItem>
              </>
            </When>
            <Otherwise>
              <>
                <InlineListItem>
                  SurveyMonkey Europe UC 2 Shelbourne Buildings, 2nd Floor,
                  Shelbourne Road, Ballsbridge, Dublin 4, Ireland
                </InlineListItem>
              </>
            </Otherwise>
          </Choose>
        </InlineList>
      </Col>
    </Row>
  );
};

BillingAddress.propTypes = {
  country: PropTypes.string,
};

BillingAddress.defaultProps = {
  country: 'US',
};

export default BillingAddress;
